<template>
    <div>
        <div class="col-12">
            <nav class="navbar navbar-expand-lg navbar-light">
                <div class="ml-auto">
                    <form class="form-inline my-2 my-lg-0">
                        <input v-model="search.name"
                               class="form-control mr-sm-2"
                               type="search"
                               placeholder="รายการวันลา"
                               aria-label="Search"
                        />
                        &nbsp;
                        <button
                            class="btn btn-success my-2 my-sm-0"
                            type="button"
                            @click="searchLeaveDay">
                            <icon name="search"></icon>
                            ค้นหา
                        </button>&nbsp;
                        <button @click="addLeaveDay"
                                class="btn btn-warning my-2 my-sm-0"
                                type="button">
                            <icon name="plus"></icon>
                            เพิ่มวันหยุด
                        </button>&nbsp;
                    </form>
                </div>
            </nav>
        </div>
        <div class="col-sm-12 table-responsive">
            <table class="table table-bordered text-center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">รายการวันลา</th>
                    <th scope="col">จำนวนวันลา(วัน)</th>
                    <th scope="col">พนักงานรายเดือน อายุงาน(เดือน)</th>
                    <th scope="col">พนักงานรายวัน อายุงาน(เดือน)</th>
                    <th scope="col">ผู้ตั้งค่า</th>
                    <th scope="col">แก้ไข</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in leave_day">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.name}}</td>
                    <td>{{data.number_of_leave}}</td>
                    <td>{{data.how_long_month}}</td>
                    <td>{{data.how_long_day}}</td>
                    <td>
                        <template v-if="data.user">
                            {{data.user.name}}
                        </template>
                        <template v-else>-</template>
                    </td>
                    <td>
                        <a @click="editLeaveDay(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp&nbsp
                        <a @click="showDeleteModal(data.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--modal-->
        <b-modal hide-footer hide-header ref="leave_day">
            <leave-day-modal @submit="hideLeaveDayModal"></leave-day-modal>
        </b-modal>
        <!--b-modal delete-->
        <b-modal hide-header hide-footer ref="delete_item">
            <div style="text-align: center;">
                <h4>คุณต้องการลบข้อมูลใช่ไหม?</h4>
                <br />
                <button type="button"
                        @click="deleteLeaveDay"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button type="button"
                        @click="hideDeleteModal"
                        class="btn btn-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
        <div v-if="leave_day.length > 0">
            <vue-pagination :pagination="dataPaginate" @paginate="Pagination">
            </vue-pagination>
        </div>
        <!--<pre class="alert alert-danger">{{ leave_day }}</pre>-->
    </div>
</template>

<script>
    import { mapState } from "vuex";
    import LeaveDayModal from "./LeaveDayModal";
    import VuePagination from "../../../Pagination";
    import DatePicker from 'vue2-datepicker'
    import moment from "moment";

    export default {
        components: {
            VuePagination,
            LeaveDayModal,
            DatePicker
        },
        name: "leave-day-list",
        data(){
            return{
                delete_id : "",
                search:{
                    name: ""
                }
            }
        },
        created(){
            this.$store.dispatch("LeaveDay/setLeaveDay");
        },
        computed:{
            ...mapState({
                leave_day :state=>{
                    return state.LeaveDay.leaveDayList.filter(data=>data.id!=9 && data.id!=10);
                },
                dataPaginate:state=>{
                    return state.LeaveDay.dataPaginate;
                },
            })
        },
        methods:{
            showLeaveDayModal(){
                this.$refs.leave_day.show();
            },
            hideLeaveDayModal(){
                this.$store.dispatch("LeaveDay/setLeaveDay");
                this.$refs.leave_day.hide();
            },
            showDeleteModal(id){
                this.delete_id = id;
                this.$refs.delete_item.show();
            },
            hideDeleteModal(){
                this.$refs.delete_item.hide();
            },
            editLeaveDay(id){
                this.showLeaveDayModal();
                this.$store.dispatch("LeaveDay/showLeaveDayById",id)
            },
            addLeaveDay(){
                this.showLeaveDayModal();
                this.$store.dispatch("LeaveDay/clearData");
            },
            deleteLeaveDay(){
                this.$store.dispatch("LeaveDay/deleteLeaveDay",this.delete_id).then(()=>{
                    this.$store.dispatch("LeaveDay/setLeaveDay");
                })
                this.hideDeleteModal();
            },
            Pagination(){
                const page = this.dataPaginate.current_page;
                this.$store.dispatch("LeaveDay/setLeaveDay",page);
            },
            searchLeaveDay(){
                this.$store.dispatch("LeaveDay/search",this.search)
            },
        }

    }
</script>

<style scoped>

</style>
